// src/utils/api.js

import { getIdToken, getAuth } from "firebase/auth";

export const backendUrl = process.env.REACT_APP_BACKEND_URL;

const getFirebaseAuthHeader = async () => {
  const user = getAuth().currentUser;
  const token = user ? await user.getIdToken() : null;
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const apiGet = async (path) => {
  const headers = {
    "Content-Type": "application/json",
    ...(await getFirebaseAuthHeader()),
  };
  const res = await fetch(`${backendUrl}${path}`, {
    method: "GET",
    headers,
  });
  return res.json();
};

export const apiPost = async (path, data) => {
  const headers = {
    "Content-Type": "application/json",
    ...(await getFirebaseAuthHeader()),
  };
  const res = await fetch(`${backendUrl}${path}`, {
    method: "POST",
    headers,
    body: JSON.stringify(data),
  });
  return res.json();
};

  
